import { UPDATE_COMMENT_REMOTE, UPDATE_COMMENT_LOCAL } from "../constants/action-types";

export const updateCommentLocal = (comment) => {
  return{type:UPDATE_COMMENT_LOCAL, payload:comment}
}

export const updateCommentRemote = (comment) => {
  return{type:UPDATE_COMMENT_REMOTE, payload:comment}
}